"use client";
import React from "react";
import "./avatars.scss"; // importa lo stile
import { Tooltip } from "../Tooltip";
import { Col, RelatedPeople } from "@/components";

type AvatarsProps = {
  users: RelatedPeople[];
  maxVisible?: number;
  size?: number;
};

const COLORS = [
  "#007bff", // blue
  "#28a745", // green
  "#dc3545", // red
  "#17a2b8", // teal
  "#6f42c1", // purple
  "#fd7e14", // orange
  "#20c997", // emerald
];

function getColorFromName(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}

export const Avatars: React.FC<AvatarsProps> = ({
  users,
  maxVisible = 5,
  size = 32,
}) => {
  const visibleUsers = users.slice(0, maxVisible);
  const hiddenCount = users.length - visibleUsers.length;

  return (
    <Tooltip
      position="bottom"
      label={
        <Col gap="x24">
          {visibleUsers.map((user) => (
            <p key={user.fiscalCode} className="text-primary">
              {user.firstName} {user.lastName}
            </p>
          ))}
        </Col>
      }
    >
      <div className="avatars-group">
        {visibleUsers.map((user, index) => {
          const bg = getColorFromName(user.firstName);
          const initial = user.firstName.charAt(0).toUpperCase();

          return (
            <div
              key={user.fiscalCode}
              className="avatar"
              style={{
                width: size,
                height: size,
                marginLeft: index === 0 ? 0 : -size / 4,
                backgroundColor: bg,
                fontSize: size * 0.45,
              }}
            >
              {initial}
            </div>
          );
        })}

        {hiddenCount > 0 && (
          <div
            className="avatar avatar-extra"
            style={{
              width: size,
              height: size,
              marginLeft: -size / 4,
              fontSize: size * 0.45,
            }}
          >
            +{hiddenCount}
          </div>
        )}
      </div>
    </Tooltip>
  );
};
